import { HttpClientBuilder } from './http-client-builder';

export const ServerClient = new HttpClientBuilder().create(process.env.REACT_APP_SERVER_BASE_URL ?? '');
